import type { ContainerRow, Permissions } from "./api";

// Pages inside one Boo still read the container-policy keys the Boo list
// used to return for the org role. Inside a Boo the Boo role decides, so map
// the Boo's own permissions onto those keys: a Boo admin sees the controls an
// org admin used to, and an org admin with no Boo role sees none.
export function containerPermissions(
  row: ContainerRow | undefined,
  listPermissions: Permissions | undefined,
): Permissions {
  const boo = row?._permissions;
  if (!boo) return listPermissions ?? null;
  return {
    ...(listPermissions ?? {}),
    canEdit: boo.canConfigure,
    canSuspend: boo.canLifecycle,
    canResume: boo.canLifecycle,
    canSoftDelete: boo.canDelete,
    canConnectSlack: boo.canAttachWorkspace,
    canConnectTeams: boo.canAttachWorkspace,
    canConnectGchat: boo.canAttachWorkspace,
    canConnectDiscord: boo.canAttachWorkspace,
    canViewSecrets: boo.canView,
    canManageSecrets: boo.canConfigure,
    canViewVault: boo.canView,
    canManageVault: boo.canConfigure,
    canViewIntegrations: boo.canView,
    // Connecting an app from a Boo makes an account private to it, so the
    // Boo's admins decide — no org role needed. Org-level connect keeps the
    // org gate (accounts._permissions).
    canManageIntegrations: boo.canConfigure,
  };
}
